import { reducerFactory } from 'common/store/scope';

import {
  SET_SELECTED,
  CLEAR_SELECTED,
} from './actions';

export const defaultState = {
  selected: null,
};

export const setSelected = (state, { selected }) => ({
  ...state,
  selected,
});

export const clearSelected = state => ({
  ...state,
  selected: null,
});

const selectionReducer = (state = defaultState, action) => {
  const reducer = {
    [SET_SELECTED]: setSelected,
    [CLEAR_SELECTED]: clearSelected,
  }[action.type];

  return reducer ? reducer(state, action) : state;
};

export const factory = namespace => reducerFactory(namespace, selectionReducer);

export default factory;
